import { com } from '@eidu/web'
import entityApiUrl from '../entity/baseUrl'
import fetchAuthorized from '../authorization/fetchAuthorized'
import SemanticLink = com.eidu.sharedlib.entity.analytics.SemanticLink
import serializeToJsonString = com.eidu.sharedlib.entity.util.serializeToJsonString

type CreateSemanticLinkParameters = {
  semanticLink: SemanticLink
}

const createSemanticLink = async ({ semanticLink }: CreateSemanticLinkParameters): Promise<void> => {
  return fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/semantic-links`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: serializeToJsonString(semanticLink),
    }
  ).then(async (response) => {
    switch (response.status) {
      case 200:
      case 201:
        return
      default:
        throw Error(`Unexpected response code ${response.status} from createSemanticLink endpoint`)
    }
  })
}

export default createSemanticLink
